import { api } from './client'

export interface NextPayment {
  amount: number
  due_date: string
  days_until: number
  order_id: number
  payment_id: number
  is_overdue: boolean
}

export interface DashboardData {
  tier: 'bronze' | 'silver' | 'gold'
  tier_score: number
  credit_limit: number
  credit_used: number
  next_payment: NextPayment | null
  unread_notifications: number
}

export async function getDashboard(): Promise<DashboardData> {
  const res = await api.get('/api/v1/users/me/dashboard')
  return res.data
}
